// noinspection SpellCheckingInspection

import { OrderDirection } from "common/contracts/order-direction";
import Date from "common/values/date/date";
import Guid from "common/values/guid/guid";

export default class WorkAgreementParameters {
  filterParameters: WorkAgreementFilterParameters;
  orderParameters: WorkAgreementOrderParameters;

  constructor(
    filterParameters: WorkAgreementFilterParameters,
    orderParameters: WorkAgreementOrderParameters
  ) {
    this.filterParameters = filterParameters;
    this.orderParameters = orderParameters;
  }

  public asSearchParams(): URLSearchParams {
    return new URLSearchParams([
      ...this.filterParameters.asSearchParams(),
      ...this.orderParameters.asSearchParams(),
    ])
  }
}

export class WorkAgreementFilterParameters {
  query?: string;

  RFPId?: Guid;

  name?: string;

  description?: string;

  clientUserId?: Guid;
  clientEntityId?: Guid;
  clientTeamMemberUserId?: Guid;
  clientTeamMemberEntityId?: Guid;

  minStart?: Date;
  maxStart?: Date;

  hasEnd?: boolean;
  minEnd?: Date;
  maxEnd?: Date;

  vendorTeamRestricted?: boolean;
  vendorUserId?: Guid;
  vendorEntityId?: Guid;
  vendorTeamMemberUserId?: Guid;
  vendorTeamMemberEntityId?: Guid;

  additionalVendorUserId?: Guid;
  additionalVendorEntityId?: Guid;

  feeScheduleCategoryId?: Guid;
  feeScheduleCategoryName?: string;
  feeScheduleCategoryDescription?: string;

  teamTemplateId?: Guid;
  teamTemplateName?: string;
  feeScheduleTemplateId?: Guid;
  feeScheduleTemplateName?: string;

  minDiscount?: number;
  maxDiscount?: number;

  isArchived?: boolean;
  maxArchived?: Date;
  minArchived?: Date;

  userId?: Guid;

  public constructor(params: Partial<WorkAgreementFilterParameters> = {}) {
    Object.assign(this, params);
  }

  public asSearchParams(): URLSearchParams {
    const params = new URLSearchParams();
    Object.entries(this).forEach(([key, value]) => {
      if (value instanceof Date) {
        params.append(key, value.toISOString())
      } else if (value !== undefined) {
        params.append(key, value?.toString() ?? "null");
      }
    });
    return params;
  }

  isEqualTo(other: WorkAgreementFilterParameters): boolean {
    return Object.entries(this).every(([key, value]) => {
      const otherValue = other[key as keyof WorkAgreementFilterParameters];
      if (value instanceof Guid && otherValue instanceof Guid) {
        return value.isEqualTo(otherValue);
      }
      if (value instanceof Date && otherValue instanceof Date) {
        return value.isEqualTo(otherValue);
      }
      return value === otherValue;
    });
  }
}

export class WorkAgreementOrderParameters {
  orderBy: WorkAgreementOrderField;
  orderDir: OrderDirection;

  constructor(
    orderBy: WorkAgreementOrderField,
    orderDir: OrderDirection
  ) {
    this.orderBy = orderBy;
    this.orderDir = orderDir;
  }

    public asSearchParams(): URLSearchParams {
      const params = new URLSearchParams();
      params.append(
        "orderBy",
        this.orderBy
      );
      params.append(
        "orderDir",
        this.orderDir
      );
      return params;
  }

  public isEqualTo(other: WorkAgreementOrderParameters): boolean {
    if (!other) return false;
    return this.orderBy === other.orderBy && this.orderDir === other.orderDir;
  }
}

export enum WorkAgreementOrderField {
  Name = "Name",
  Start = "Start",
  End = "End",
  Discount = "Discount",
  Archived = "Archived"
}